module.exports = __webpack_public_path__ + "static/media/sub_logo_.427cf098.svg";